import React from 'react';
import Layout from './layout';
import Emoji from './emoji';
import { useTranslation } from 'react-i18next';

const About = () => {
    const { t } = useTranslation();

    return (
        <Layout selected="about">
            <div className="container min-vh-100">
                <p>
                    <Emoji emoji="👋" label="waving hand" /> {t('about-intro')}
                </p>
                <img src="https://s3.us-west-2.amazonaws.com/photos.torgyd.com/vallard-300.png" alt="Vallard" className="img-fluid" />
                <p className="mt-2">{t('about-trip')}</p>

                <h4>{t('about-connect-heading')}</h4>
                <p>{t('about-social-issues')}</p>
                <ul>
                    <li>
                        <b>{t('about-loneliness-title')}</b> {t('about-loneliness-text')}{' '}
                        (<a href="https://www.who.int/director-general/speeches/detail/who-director-general-s-opening-remarks-at-the-media-briefing-15-november-2023">{t('about-source')}</a>)
                        <p className="mt-3">{t('about-good-life')}</p>
                    </li>
                    <li>
                        <b>{t('about-empower-title')}</b> {t('about-empower-text')}
                    </li>
                </ul>

                <p className="mt-2">{t('about-travel-peace')}</p>
                <h3 className="mt-2">{t('about-money-heading')}</h3>
                <p>{t('about-money-text')}</p>
                <ul>
                    <li>{t('about-listeners')}</li>
                    <li>{t('about-guides')}</li>
                    <li>{t('about-eatwith')}</li>
                </ul>
                <p>{t('about-subscription')}</p>
            </div>
        </Layout>
    );
}

export default About;
